import { useEffect, useState } from "react";
import { DELETE_PAGE, SELECT_PAGE, TOGGLE_DELETE_PAGE_DIALOG } from "../../../Context/Display/Pages/PagesContextEvents";
import usePages from "../../../Hooks/Display/usePages";
import { deletePage } from "../../Helpers/DisplayConfig/DisplayConfig";
import RemoveDialog from "../../Shared/Remove/RemoveDialog";

function DeletePageDialog() {

    const [{ pages, deletePageIndex }, dispatchPageEvent] = usePages();

    const [page, setPage] = useState({});

    useEffect(() => {
        if (!deletePageIndex) {
            setPage({});
            return;
        }
        debugger
        const pagePosition = deletePageIndex.split("_").map(x => parseInt(x));
        const page = pages[pagePosition[0]].items[pagePosition[1]];
        setPage(page);
    }, [deletePageIndex])

    function toggleDeleteDialog() {
        dispatchPageEvent({
            type: TOGGLE_DELETE_PAGE_DIALOG
        })
    }

    async function handleDelete() {
        await deletePage(page._id || page.id);
        dispatchPageEvent({
            type: DELETE_PAGE,
            payload: {
                parentId: page.parentId,
                pageId: page._id
            }
        })
        const newPageIndex = deletePageIndex.split("_")[0] + "_" + (deletePageIndex.split("_")[1] - 1);

        dispatchPageEvent({
            type: SELECT_PAGE,
            payload: newPageIndex
        })

        toggleDeleteDialog();
    }

    return (
        <RemoveDialog
            Title="Delete Page"
            toggleDeleteDialog={toggleDeleteDialog}
            message={`Are you sure you want to delete the ${page.text} page?`}
            onDelete={handleDelete}
            onCancel={toggleDeleteDialog}
            deleteButtonText="Delete" />
    )
}

export default DeletePageDialog;